import { RouteRecordRaw } from 'vue-router';
import { RecordConfigPage } from '@/pages/registry-management';

export const routeName = 'GestaoRegistrosConfigurarRegistro';

export const route: RouteRecordRaw = {
  path: 'gestao-registros/registros/:id/configurar',
  name: routeName,
  component: RecordConfigPage,
  meta: {
    requiresAuth: true,
    breadcrumb: 'Configurar Registro',
    dynamicBreadcrumb: true,
    permissions: [{ action: 'manage', subject: 'RecordManagement' }],
  },
};
